"use client";

import React, { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Image from "next/image";
import CounterImg from "../../../public/assets/backgrounds/counter_bg.png";
gsap.registerPlugin(ScrollTrigger);

const counterData = [
  { label: "Satisfied Clients", value: 500, suffix: "+" },
  { label: "Years of Experience", value: 12, suffix: "+" },
  { label: "Projects", value: 1, suffix: "K" },
  { label: "Awards", value: 34, suffix: "" },
];

const Counter = () => {
  const countersRef = useRef<Array<HTMLSpanElement | null>>([]);

  useGSAP(() => {
    countersRef.current.forEach((el, index) => {
      const finalValue = counterData[index].value;
      const suffix = counterData[index].suffix || "";
      const obj = { val: 0 };

      gsap.to(obj, {
        val: finalValue,
        duration: 2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
          toggleActions: "play none none none",
        },
        onUpdate: () => {
          if (el) {
            el.textContent = Math.floor(obj.val).toString() + suffix;
          }
        },
      });
    });
  }, []);

  return (
    <section className="relative ">
      <Image src={CounterImg} alt="Counter Background" loading="lazy" className="h-[80vh] object-cover" />
      <div className="absolute top-0 left-0 w-full h-full bg-black opacity-85 bl" />
      <div className="container mx-auto absolute top-1/2 left-1/2 -translate-1/2">
        <div className="grid xl:grid-cols-4 grid-cols-2 gap-6">
          {counterData.map((item, i) => (
            <div key={i} className=" p-5 group">
              <div className="xl:w-[180px] w-30 xl:h-[180px] h-30  relative counter-border ">
                <span
                  ref={(el) => {
                    countersRef.current[i] = el;
                  }}
                  className="xl:text-5xl text-xl font-medium text-white"
                >
                  0
                </span>
              </div>
              <p className="text-base text-center font-semibold tracking-wide text-white mt-10 uppercase">
                {item.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Counter;
